import { register } from 'swiper/element/bundle';
register();
